import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Dialog from "@mui/material/Dialog";
import CloseIcon from "@mui/icons-material/Close";
import moment from "moment-timezone";
import {
  Checkbox,
  TextField,
  MenuItem,
  FormControlLabel,
  Tooltip,
} from "@mui/material";
import QRCode from "qrcode.react";
import { useContext, useEffect, useRef, useState } from "react";
import { Loading, useRedirect } from "react-admin";
// import { Form, FormSpy } from "react-final-form";
import { Controller, useForm } from "react-hook-form";
import { BiPlusCircle, BiQrScan, BiTrash } from "react-icons/bi";
import { FiLogIn, FiLogOut, FiRefreshCw } from "react-icons/fi";
import { useParams } from "react-router";
import { useNavigate } from "react-router-dom";
import { routePaths } from "../../baseLayout/SidebarMenu";
import AttendeeTimelinePopup from "../../components/AttendeeTimeline/AttendeeTimelinePopup";
import NotificationMessage, {
  notificationType,
} from "../../components/NotificationMessage/NotificationMessage";
import { registrationStatus } from "../../dataProvider/interfaces/IAttendee";
import { IAttendeeCategory } from "../../dataProvider/interfaces/IEvent";
import { useHasPermissions } from "../../hooks/useHasPermissions";
import { PERMISSIONS } from "../../roles";
import { APIContext } from "../../store/APIStore";
import { StoreContext } from "../../store/Store";
import {
  actionDialogType,
  InfoFieldForm,
  RouteLeavingGuard,
  SimpleActionDialog,
} from "./../../components";
import { Props as dialogType } from "./../../components/SimpleActionDialog/SimpleActionDialog";
import packageJson from "../../../package.json";
import { getTimeline } from "../../components/AttendeeTimeline/AttendeeTimeline";
import { v4 as uuidv4 } from "uuid";
import { theme } from "../../theme";
import FdButton from "../../components/UIComponents/Button/FdButton";
import FdIconButton from "../../components/UIComponents/IconButton/FdIconButton";
import FdTextField from "../../components/UIComponents/TextField/FdTextfield";
import FdAvatar from "../../components/UIComponents/Avatar/FdAvatar";
import FdTypography from "../../components/UIComponents/Typography/FdTypography";
import React from "react";
import { DatePicker, TimePicker } from "@mui/x-date-pickers";
import FdSelect from "../../components/UIComponents/Select/FdSelect";
import { AssignReservations } from "../AssignReservations/AssignReservations";
import { RiAddCircleLine, RiAlertLine } from "react-icons/ri";
import CategoryOverview from "./AttendeeCategory/CategoryOverview";


const classes = {
  wrapper: {
    display: "flex",
    justifyContent: "space-between",
  },
  contentWrapper: {
    height: "calc(100vh - 105px)",
    display: "flex",
    flexDirection: "column",
    // width: "74%", the width of the content part if we show the badge preview
    width: "100%",
  },
  topActions: {
    display: "flex",
    alignItems: "center",
    paddingBottom: "20px",
    justifyContent: "space-between",
  },
  infoTitle: {
    display: "flex",
    flexGrow: 1,
    alignItems: "center",
    maxWidth: "calc(100% - 570px)"
  },
  formTitle: {
    backgroundColor: "#fff",
    padding: "20px",
  },
  userImage: {
    width: "5vw",
    height: "5vw",
    maxWidth: "100px",
    maxHeight: "100px",
    position: "relative",
    marginRight: "25px",
  },
  closeButton: {},
  formContent: {
    position: "relative",
    width: "100%",
    flexGrow: 1,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    overflow: "auto",
    "& .MuiFormControl-root": {
      my: 0,
    },
    "& .MuiFormHelperText-root ": {
      mx: 0,
    },
    "& form": {
      width: "100%",
      textAlign: "left",
      height: "100%",
      display: "contents",
    },
  },
  genericFields: {
    width: "55%",
    height: "100%",
    backgroundColor: theme.palette.grey[600],
    overflow: "auto",
    borderRadius: "5px",
  },
  customFields: {
    width: "40%",
    height: "100%",
    backgroundColor: theme.palette.grey[600],
    overflow: "auto",
    borderRadius: "5px",
    display: "flex",
    flexDirection: "column",
  },
  dateField: {
    marginBottom: "15px",
  },
  timeField: {
    marginBottom: "15px",
  },
  formFields: {
    padding: "10px 20px",
    textAlign: "left",
  },
  inputIcon: {
    fontSize: "18px",
    color: theme.palette.grey["800"],
  },
  addInfoFieldButton: {
    position: "sticky",
    bottom: 0,
    left: 0,
    right: 0,
    height: "60px",
    backgroundColor: theme.palette.primary.main,
    zIndex: 11,
    color: "#fff",
    fontSize: "18px",
    display: "flex",
    alignItems: "center",
    padding: "0 10px",
    justifyContent: "center",
    cursor: "pointer",
    marginTop: "auto",
    minHeight: "60px",
  },
  addIcon: {
    color: "#fff",
    marginRight: "5px",
    fontSize: "18px",
  },
  checkboxesGroup: {
    transformOrigin: "top left",
    transform: "translate(0, 3.5px) scale(0.75)",
  },
  checkboxesGroupInput: {
    "& > span": {
      paddingBottom: "2px",
      paddingTop: "2px",
    },
  },
  attendeeAvatar: {
    width: "100%",
    height: "100%",
  },
};
const customStyle = {
  "& .MuiInputBase-root.MuiFilledInput-root": {
    border: "1px solid #E7E7E7",
    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.05)",
    borderRadius: "6px !important",
    padding: "12px 10px",
    background: "#fff",
    "&:before,&:after": {
      display: "none",
    },
    "&:hover": {
      background: "#fff",
    },
    "& input": {
      border: 0,
      boxShadow: "none",
      padding: "0 !important",
    },
  },
  "&.noPastErrorStyle .Mui-error": {
    color: theme.palette.text.primary,
  },
  "&.noPastErrorStyle .Mui-error.MuiFormHelperText-root ": {
    color: theme.palette.error.main,
  },

  "& .MuiButtonBase-root ": {
    "& svg": {
      height: "18px",
      width: "18px",
      color: "#A8A8A8",
    },
  },
};
const ERROR_DUPLICATE_FIELD = "This field already exists, try a different name or use the existing one.";

// Fields only the onsite app may change; the backend ignores portal updates to them.
const PROTECTED_CUSTOM_FIELD_NAMES = ["consent_response"];
const PROTECTED_CUSTOM_FIELD_HELPER_TEXT = "Can only be updated from the onsite app";
const isAppOnlyField = (fieldName: any): boolean =>
  PROTECTED_CUSTOM_FIELD_NAMES.includes(String(fieldName ?? "").toLowerCase());

const AttendeeEdit = () => {
  const randomId = uuidv4();
  const selectedCategory = useRef<number>(-1);
  const [loading, setLoading] = useState(true);
  const [attachedImage] = useState<File>();
  const [attendeeFields, setAttendeeFields] = useState<any>([]);
  const [currentAttendee, setCurrentAttendee] = useState<any>(null);
  const [fieldMap, setFieldMap] = useState<Map<string, string>>(new Map([]));
  const [defaultAttendeeValues] = useState<any>({
    thirdPartyId: randomId,
    // registrationStatus: registrationStatus.CONFIRMED,
    barcode: randomId,
    fieldValues: [],
  });
  const [confirmationDialog, setConfirmationDialog] = useState<dialogType>({
    open: false,
    title: "",
    type: actionDialogType.REGULAR,
    isLoading: false,
    onConfirm: () => { },
  });

  const [timelineOpened, setTimelineOpened] = useState<boolean>(false);

  const [dirtyForm, setDirtyForm] = useState(false);
  const [popoutQR, setPopoutQR] = useState(false);
  // const [qrFieldName, setQRFieldName] = useState("");
  const [state, dispatch] = useContext(StoreContext);
  const api = useContext(APIContext);
  const { eventId, attendeeId } = useParams() as any;
  const redirect = useRedirect();
  const notificationRef = useRef<any>();
  const allowNavigationRef = useRef(true);
  let navigate = useNavigate();
  let attendeeIsCheckedIn = false;
  let lastSeenAt = "-";
  let lastSeenLocation = "-";
  const kioskInfo = {
    kioskId: window.navigator.userAgent,
    kioskName: "fdPortal",
    osVersion: "",
    appVersion: packageJson.version,
    operator: state?.currentUser?.username,
    location: window.location.host,
  };

  function showQRHandlerFactory(fieldName: string) {
    return () => {
      // setQRFieldName(fieldName);
      setPopoutQR(true);
    };
  }

  // permissions
  const canManageAttendee = useHasPermissions(PERMISSIONS.CAN_MANAGE_ATTENDEE);

  async function loadData() {
    // load selected event
    if (eventId && !state.selectedEvent) {
      await fetchSelectedEvent();
    }

    if (!state?.attendeeCategoriesList?.isApiCallDone) {
      await fetchAttendeeCategories();
    }
    // load attendee custom fields
    await fetchAttendeeFields();
    // load the selected attendee
    if (attendeeId) {
      await fetchAttendee();
    }
    setLoading(false);
  }

  useEffect(() => {
    loadData();
    return () => {
      setAttendeeFields([]);
      setCurrentAttendee(null);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (currentAttendee?.category && selectedCategory.current < 0) selectedCategory.current = currentAttendee.category;
  const initialValues = {
    fname: currentAttendee?.fieldValues?.fname,
    lname: currentAttendee?.fieldValues?.lname,
    thirdPartyId:
      currentAttendee?.thirdPartyId || defaultAttendeeValues.thirdPartyId,
    id: currentAttendee?.id,
    email: currentAttendee?.fieldValues?.email,
    categoryId: currentAttendee?.category,
    registrationStatus:
      currentAttendee?.registrationStatus ||
      defaultAttendeeValues.registrationStatus,
    lastSeenAt: lastSeenAt,

    barcode:
      currentAttendee?.barcode ||
      currentAttendee?.thirdPartyId ||
      defaultAttendeeValues.barcode,
    balanceDue: currentAttendee?.balanceDue,
    checkinMode: currentAttendee?.fieldValues?.checkinMode,
    checkinLocation: currentAttendee?.location,
    company: currentAttendee?.fieldValues?.company,
    country: currentAttendee?.fieldValues?.country,
  };
  const {
    register,
    handleSubmit,
    control,
    reset,
    watch,
    setValue,
    formState: { isDirty, errors },
  } = useForm({
    defaultValues: initialValues,
    mode: "onBlur",
  });

  const values = watch("barcode");

  useEffect(() => {
    reset(initialValues);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentAttendee, reset]);

  const getFieldName = (name: string): string => {
    if (name) {
      const returnData = fieldMap.get(String(name).toLowerCase());
      if (returnData) return returnData;
    }
    return name;
  };

  const fetchAttendeeFields = async () => {
    try {
      const data = await api.eventService.getAttendeeFields(eventId);
      if (data && Array.isArray(data) && data.length) {
        const currentMap = new Map(fieldMap);
        data.forEach(each => {
          if (!fieldMap.has(String(each.fieldName).toLowerCase())) {
            currentMap.set(String(each.fieldName).toLowerCase(), each.fieldName);
          }
        });
        // console.log("sam log currentMap 1", currentMap);
        setFieldMap(currentMap);
      }
      setAttendeeFields(data);
    } catch (error: any) {
      console.log(error.response);
      notificationRef.current?.show(
        error.response.data.message,
        notificationType.Error
      );
    }
  };

  const fetchAttendeeCategories = async () => {
    try {
      const data = (await api.eventService.getAttendeeCategories(
        eventId
      )) as any;
      dispatch({ type: "SET_ATTENDEE_CATEGORIES_LIST", payload: { list: data, isApiCallDone: true, loading: true } });
    } catch (error: any) {
      console.log(error.response);
      notificationRef.current?.show(
        error.response.data.message,
        notificationType.Error
      );
    }
  };

  const fetchSelectedEvent = async () => {
    try {
      const event = await api.eventService.getEvent({ id: eventId });
      dispatch({ type: "SET_SELECTED_EVENT", payload: event });
    } catch (error: any) {
      console.log(error.response);
      notificationRef.current?.show(
        error.response.data.message,
        notificationType.Error
      );
    }
  };

  const fetchAttendee = async () => {
    try {
      const attendee = await api.attendeeService.getAttendee(attendeeId);
      if ("fieldValues" in attendee) {
        const currentMap = new Map(fieldMap);
        Object.keys(attendee?.fieldValues || {}).forEach(each => {
          currentMap.set(String(each).toLowerCase(), each);
        });
        // console.log("sam log currentMap 2", currentMap);
        setFieldMap(currentMap);
      }
      setCurrentAttendee(attendee);
    } catch (error: any) {
      console.log(error);
      notificationRef.current?.show(
        error.response?.data.message,
        notificationType.Error
      );
    }
  };

  const onSubmit = async (values: any) => {
    const submittedValues = {
      ...values,
      fieldValues: {
        fname: values.fname,
        lname: values.lname,
        email: values.email,
      },
    };

    // handle custom field values
    const customFields = attendeeFields.filter(
      (field: any) => field.visible === true
    );
    customFields.forEach((field: any) => {
      if (isAppOnlyField(field.fieldName)) return;
      const name = getCustomFieldName(getFieldName(field.fieldName));
      if (submittedValues[name]) {
        const value = Array.isArray(values[name])
          ? values[name].join(",")
          : values[name];
        if (!Array.isArray(values[name])) {
          // TODO remove this condition after decide how we should store array values for checkboxes
          submittedValues.fieldValues[getFieldName(field.fieldName)] = value;
        }
      }
    });

    if (currentAttendee) {
      updateAttendee(submittedValues);
    } else {
      const newAttendee = await createAttendee(submittedValues);
      if (newAttendee) {
        allowNavigationRef.current = true
        redirect(`/${routePaths.EVENTS}/${eventId}/${routePaths.ATTENDEES}/${newAttendee.id}/${routePaths.EDIT}`);
      }
    }

    setDirtyForm(false);
  };
  const showInvalidateBarcodeDialog = () => {
    setConfirmationDialog({
      open: true,
      title:
        "Are you sure you want to invalidate this attendee's barcode? This will render his current badge unusable for session scanning.",
      icon: <BiQrScan size="45" />,
      type: actionDialogType.WARNING,
      isLoading: false,
      onConfirm: () => {
        handleInvalidateAttendeeBarcode();
      },
      onCancel: handleDialogClose,
    });
  };

  const handleInvalidateAttendeeBarcode = async () => {
    try {
      const response = (await api.attendeeService.blockBarcode(
        state.selectedEvent.id,
        currentAttendee.thirdPartyId,
        {
          barcode: uuidv4(),
          kioskInformation: kioskInfo,
        }
      )) as any;
      setCurrentAttendee({
        ...currentAttendee,
        barcode: response.barcode,
        barcodeBlocked: true,
      });
      setConfirmationDialog({
        open: false,
      });
    } catch (error: any) {
      console.log(error.response);
      notificationRef.current?.show(
        error.response.data.message,
        notificationType.Error
      );
    }
  };

  const updateAttendee = async (values: any) => {
    try {
      const newAttendee = { ...values };
      newAttendee.emailAddress = newAttendee.email;
      delete newAttendee.email;

      // process image file
      if (attachedImage) {
        const imageData = (await api.fileService.uploadImageFile("attendees", {
          resourceId: currentAttendee.id,
          file: attachedImage,
        })) as any;
        newAttendee.imageUrl = imageData.image;
      }

      // update attendee
      const updatedAttendee = await api.attendeeService.updateAttendee(
        currentAttendee.id,
        newAttendee
      );
      setCurrentAttendee(updatedAttendee);

      // show notification
      notificationRef.current?.show(
        "Attendee successfully saved",
        notificationType.Success
      );
    } catch (error: any) {
      console.log(error.response);
      notificationRef.current?.show(
        error.response.data.message,
        notificationType.Error
      );
    }
  };

  const createAttendee = async (values: any) => {
    try {
      // let attendeeImage;
      const result = await api.attendeeService.createAttendee(state.selectedEvent.id, values) as any;
      if (result) {
        setCurrentAttendee(result)
        // (result)
      }
      // const newAttendee = data;

      // TODO, attendee avatar not supported by API
      //
      // if (attachedImage) {
      //   const imageData = await dataProvider.uploadImageFile("attendees", {
      //     resourceId: currentAttendee.id,
      //     file: attachedImage,
      //   });
      //   attendeeImage = imageData.image;

      //   // attach attendee image
      //   const { data } = await dataProvider.updateAttendee(currentAttendee.id, {
      //     ...newAttendee,
      //     imageUrl: attendeeImage,
      //   });
      // }

      notificationRef.current?.show(
        "Attendee successfully saved",
        notificationType.Success
      );
      return result;
    } catch (error: any) {
      console.log('error', error);
      notificationRef.current?.show(
        error.response.data.message,
        notificationType.Error
      );
    }
  };

  // async function validate(values: any) {
  //   return;
  // }

  if (currentAttendee?.attendeeCheckHistories?.length > 0) {
    const sortedCheckHistories = [
      ...currentAttendee.attendeeCheckHistories,
    ].sort(
      (a, b) => new Date(a.checkAt).valueOf() - new Date(b.checkAt).valueOf()
    );
    const check_ins_and_outs = sortedCheckHistories.filter(elem => (elem.type.id === 1 || elem.type.id === 2));
    const hasResetAction = [...sortedCheckHistories].pop();
    attendeeIsCheckedIn = check_ins_and_outs.length > 0 && check_ins_and_outs[check_ins_and_outs?.length - 1].type.id === 1;
    if (attendeeIsCheckedIn && hasResetAction?.type?.id === 7) attendeeIsCheckedIn = false;

    if (currentAttendee?.checkinAt) {
      // If this is null, but checkHistories aren't, attendee was reset => leave lastSeenAt = '-'
      const timeline = getTimeline(currentAttendee);

      // const sortedCheckHistories = [...currentAttendee.attendeeCheckHistories]
      // .sort((a, b) => new Date(a.checkAt).valueOf() - new Date(b.checkAt).valueOf());

      const lastNode = timeline[timeline?.length - 1];
      lastSeenAt = moment
        .utc(lastNode.time)
        .tz(state?.selectedEvent?.timeZone)
        .format("YYYY-MM-DD HH:mm");
      setValue("lastSeenAt", lastSeenAt);
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      lastSeenLocation = lastNode.location;
    }
  }

  const disableCheckButton =
    currentAttendee?.registrationStatus === registrationStatus.CANCELLED ||
    currentAttendee?.registrationStatus === registrationStatus.INCOMPLETE;

  const disablePast = true;
  const getCustomField = (field: any) => {
    const appOnly = isAppOnlyField(field.fieldName);
    const appOnlyHelperText = appOnly ? PROTECTED_CUSTOM_FIELD_HELPER_TEXT : undefined;
    switch (field.dataType) {
      case "TEXT_ONE_LINE_FIELD": {
        currentAttendee?.fieldValues[getFieldName(field.fieldName)] &&
          ((initialValues as any)[getFieldName(field.fieldName)] =
            currentAttendee?.fieldValues[getFieldName(field.fieldName)]);
        return (
          <Box key={field.id} marginBottom="15px">
            <FdTextField
              register={register}
              disabled={
                appOnly ||
                field.fieldName === "fname" ||
                field.fieldName === "lname" ||
                field.fieldName === "email"
              }
              helperText={appOnlyHelperText}
              name={getCustomFieldName(getFieldName(field.fieldName))}
              label={field.label}
              InputLabelProps={{
                onDoubleClick: showQRHandlerFactory(
                  getCustomFieldName(getFieldName(field.fieldName))
                ),
              }}
            />
          </Box>
        );
      }
      case "STATIC_LABEL_FIELD": {
        currentAttendee?.fieldValues[getFieldName(field.fieldName)] &&
          ((initialValues as any)[getFieldName(field.fieldName)] =
            currentAttendee?.fieldValues[getFieldName(field.fieldName)]);
        return (
          <Box key={field.id}>
            <FdTextField
              register={register}
              name={getCustomFieldName(getFieldName(field.fieldName))}
              label={field.label}
              disabled
            />
          </Box>
        );
      }
      case "UNDEFINED_FIELD": {
        currentAttendee?.fieldValues[getFieldName(field.fieldName)] &&
          ((initialValues as any)[getFieldName(field.fieldName)] =
            currentAttendee?.fieldValues[getFieldName(field.fieldName)]);
        return (
          <Box key={field.id}>
            <FdTextField
              register={register}
              name={getCustomFieldName(getFieldName(field.fieldName))}
              label={field.label}
              disabled={appOnly}
              helperText={appOnlyHelperText}
            />
          </Box>
        );
      }
      case "OPTION_LIST_OF_TEXTS_FIELD": {
        // for OPTION_LIST_OF_TEXTS_FIELD the values should be stored as a JSON array
        Array.isArray(currentAttendee?.fieldValues[getFieldName(field.fieldName)]) &&
          setCustomFieldValue(
            field.dataType,
            getFieldName(field.fieldName),
            currentAttendee?.fieldValues[getFieldName(field.fieldName)]
          );

        const checkboxData = field.optionList.map((option: any) => ({
          label: option.name.trim(),
          value: option.name.trim(),
        }));

        return (
          <>
            {/* {field.typeLabel === "Dropdown box" && (
              <Box key={field.id} paddingBottom="15px">
                <Select
                  name={getCustomFieldName(field.fieldName)}
                  label={field.label}
                  disableUnderline
                  inputProps={{
                    className: classes.selectField,
                  }}
                >
                  {field.optionList.map((option: any) => (
                    <MenuItem key={option.id} value={option.key}>
                      {option.name}
                    </MenuItem>
                  ))}
                </Select>
              </Box>
            )}

            {field.typeLabel === "Radio buttons" && (
              <Box key={field.id} paddingBottom="15px">
                <Radios
                  label={
                    field.fieldName.charAt(0).toUpperCase() +
                    field.fieldName.slice(1)
                  }
                  name={getCustomFieldName(field.fieldName)}
                  data={checkboxData}
                  formControlLabelProps={{
                    className: classes.checkboxesGroupInput,
                  }}
                  formLabelProps={{
                    className: classes.checkboxesGroup,
                  }}
                />
              </Box>
            )} */}

            <Box key={field.id} paddingBottom="15px">
              {Array.isArray(currentAttendee?.fieldValues[getFieldName(field.fieldName)]) ? (
                <FormControlLabel
                  control={<Checkbox />}
                  label={checkboxData.label}
                  checked={checkboxData.value}
                />
              ) : (
                <FdTextField
                  register={register}
                  name={getCustomFieldName(getFieldName(field.fieldName))}
                  label={field.label}
                  placeholder={"Values could not be parsed"}
                  disabled
                />
              )}
            </Box>
          </>
        );
      }
      case "TEXT_MULTIPLE_LINES_FIELD": {
        currentAttendee?.fieldValues[getFieldName(field.fieldName)] &&
          ((initialValues as any)[getFieldName(field.fieldName)] =
            currentAttendee?.fieldValues[getFieldName(field.fieldName)]);
        return (
          <Box key={field.id}>
            <FdTextField
              register={register}
              name={getCustomFieldName(getFieldName(field.fieldName))}
              label={field.label}
              disabled={appOnly}
              helperText={appOnlyHelperText}
              multiline
              rows={6}
              maxRows={6}
            />
          </Box>
        );
      }
      case "DATE_FIELD": {
        (initialValues as any)[getFieldName(field.fieldName)] =
          currentAttendee?.fieldValues[getFieldName(field.fieldName)] &&
            currentAttendee?.fieldValues[getFieldName(field.fieldName)] !== "0000-00-00"
            ? moment(currentAttendee?.fieldValues[getFieldName(field.fieldName)]).format(
              "MMMM DD YYYY"
            )
            : null;
        return (
          <Box key={field.id}>
            {/* <LocalizationProvider adapterLocale={AdapterDateFns}>
              <DatePicker
                variant="inline"
                label={field.label}
                required={false}
                name={getCustomFieldName(field.fieldName)}
                format="yyyy.MM.dd"
                dateFunsUtils={DateFnsUtils}
                components={{
                  OpenPickerIcon: BiCalendar,
                }}
                sx={customStyle}
              />
            </LocalizationProvider> */}
            <Controller
              {...register(getCustomFieldName(getFieldName(field.fieldName)))}
              control={control}
              defaultValue={new Date()}
              render={({ field: { onBlur, name, ...fieldValue } }) => (
                <>
                  <DatePicker
                    label={field.label}
                    {...fieldValue}
                    disabled={appOnly}
                    // inputRef={ref}
                    format="yyyy.MM.dd, HH:mm"
                    disablePast={disablePast}
                    className={disablePast ? "noPastErrorStyle" : ""}
                    sx={customStyle}
                  />
                </>
              )}
            />
          </Box>
        );
      }
      case "TIME_FIELD": {
        (initialValues as any)[getFieldName(field.fieldName)] =
          currentAttendee?.fieldValues[getFieldName(field.fieldName)];
        return (
          <Controller
            {...register(getCustomFieldName(getFieldName(field.fieldName)))}
            control={control}
            defaultValue={new Date()}
            render={({ field: { onBlur, name, ...fieldValue } }) => (
              <>
                <TimePicker
                  label={field.label}
                  {...fieldValue}
                  disabled={appOnly}
                  // inputRef={ref}
                  format="HH:mm"
                  disablePast={disablePast}
                  className={disablePast ? "noPastErrorStyle" : ""}
                  sx={customStyle}
                />
              </>
            )}
          />
          // <LocalizationProvider adapterLocale={AdapterDateFns}>
          //   <TimePicker
          //     // label={field.label}
          //     name={getCustomFieldName(field.fieldName)}
          //     format="HH:mm"
          //     dateFunsUtils={DateFnsUtils}
          //     InputProps={{
          //       className: classes.timeField,
          //       endAdornment: (
          //         <InputAdornment position="end" sx={classes.inputIcon}>
          //           <BiTime />
          //         </InputAdornment>
          //       ),
          //     }}
          //   />
          // </LocalizationProvider>
        );
      }
      case "BOOLEAN_FIELD": {
        // const checkboxData: CheckboxData[] = field.optionList.map(
        //   (option: any) => ({
        //     label: option.name.trim(),
        //     value: option.key,
        //   })
        // );
        return (
          <Box key={field.id} paddingBottom="15px">
            <FormControlLabel
              control={<Checkbox />}
              label={field.label}
              checked={field.value}
              disabled={appOnly}
            />
          </Box>
        );
      }
      default: {
        return <Box key={field.id}></Box>;
      }
    }
  };

  const getCustomFieldName = (fieldName: any) => {
    return !parseInt(fieldName) ? fieldName : "_" + fieldName; // cannot use numeric strings as field names
  };

  const setCustomFieldValue = (
    fieldType: any,
    fieldName: any,
    fieldValue: any
  ) => {
    const customName = getCustomFieldName(fieldName);
    if (fieldType === "OPTION_LIST_OF_TEXTS_FIELD") {
      (initialValues as any)[customName] = fieldValue.map((value: any) =>
        value.trim()
      );
    } else {
      (initialValues as any)[customName] = fieldValue;
    }
  };

  const getVisibleCustomFields = () => {
    const visibleFields = attendeeFields.filter(
      (field: any) =>
        field.visible === true &&
        field.fieldName !== "fname" &&
        field.fieldName !== "lname" &&
        field.fieldName !== "email"
    );
    if (visibleFields?.length) {
      return visibleFields.map((field: any) => {
        return getCustomField(field);
      });
    }
    return;
  };

  const showDeleteDialog = () => {
    setConfirmationDialog({
      open: true,
      title: "Are you sure you want to delete this attendee?",
      icon: <BiTrash size="45" />,
      type: actionDialogType.WARNING,
      isLoading: false,
      onConfirm: () => {
        dirtyForm && setDirtyForm(false); // we don't want to show the form leave warning when redirecting after deletion
        handleDeleteAttendee();
      },
      onCancel: handleDialogClose,
    });
  };

  const handleDeleteAttendee = async () => {
    try {
      setConfirmationDialog({
        ...confirmationDialog,
        open: true,
        title: "Deleting attendee...",
        isLoading: true,
      });
      await api.attendeeService.delete(currentAttendee?.id);

      redirect(
        `/${routePaths.EVENTS}/${state.selectedEvent?.id}/${routePaths.ATTENDEES}`
      );
    } catch (error: any) {
      console.log(error.response);
      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
        title: "Deleting attendee...",
        isLoading: false,
      });
      notificationRef.current?.show(
        error.response.data.message,
        notificationType.Error
      );
    }
  };

  const handleDialogClose = () => {
    if (confirmationDialog.title === "Assign Reservations") {
      const { selectedReservationItems } = state;
      if (selectedReservationItems?.length && selectedReservationItems?.length > 0) {
        showConfirmationDialog();
      } else {
        setConfirmationDialog({
          open: false,
          title: "",
          isLoading: false,
        });
      }
    }
    else {
      setConfirmationDialog({
        open: false,
      });
    }
  };

  const showConfirmationDialog = () => {
    setConfirmationDialog({
      open: true,
      title: "Are you sure you want to close without save?",
      icon: <RiAlertLine size="45" />,
      type: actionDialogType.WARNING,
      isLoading: false,
      onConfirm: closeConfirmationDialog,
      onCancel: assignReservationDialog,
    });
  };
  const closeConfirmationDialog = () => {
    setConfirmationDialog({
      ...confirmationDialog,
      open: false,
    });
  }

  const showInfoFieldDialog = () => {
    setConfirmationDialog({
      open: true,
      title: "Add new infofield",
      content: <InfoFieldForm />,
      onConfirm: () => {
        createAttendeeField();
      },
      confirmLabel: "Add infofield",
    });
  };

  const createAttendeeField = async () => {
    // get data from dialog inputs
    const fieldName = (
      document.getElementById("customFieldName") as HTMLInputElement
    )?.value;
    const fieldLabel = (
      document.getElementById("customFieldLabel") as HTMLInputElement
    )?.value;

    if (fieldName.length && fieldLabel.length) {
      // change dialog state to loading
      setConfirmationDialog({
        open: true,
        title: "Creating new infofield...",
        isLoading: true,
        onConfirm: () => { },
      });

      try {
        // call the api
        await api.attendeeFieldService.createAttendeeField(
          state.selectedEvent.id,
          {
            fieldName,
            label: fieldLabel,
            required: false,
            visible: true,
            dataType: "TEXT_ONE_LINE_FIELD",
          }
        );
      } catch (error: any) {
        console.log(error.response);
        let errorMessage = error?.response?.data?.message || "";
        if (errorMessage?.includes("Duplicate")) errorMessage = ERROR_DUPLICATE_FIELD;
        notificationRef.current?.show(
          errorMessage,
          notificationType.Error
        );
      }

      // reload custom fields
      await fetchAttendeeFields();

      // close the dialog
      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });
    }
  };

  const showCheckWarning = (checkOut: boolean) => {
    setConfirmationDialog({
      open: true,
      title: `Are you sure you want to check ${checkOut ? "out" : "in"
        } this attendee?`,
      icon: checkOut ? <FiLogOut size="45" /> : <FiLogIn size="45" />,
      type: actionDialogType.WARNING,
      isLoading: false,
      onConfirm: () => handleCheckAttendee(checkOut),
      onCancel: handleDialogClose,
    });
  };

  const handleCheckAttendee = async (checkOut: boolean) => {
    // change dialog state to loading
    setConfirmationDialog({
      ...confirmationDialog,
      open: true,
      title: "Processing data...",
      isLoading: true,
    });
    try {
      if (checkOut) {
        await api.attendeeService.checkOut(eventId, attendeeId, moment(), {
          ...kioskInfo,
          checkinMode: "Lookup",
        });
      } else {
        await api.attendeeService.checkIn(eventId, attendeeId, moment(), {
          ...kioskInfo,
          checkinMode: "Lookup",
        });
      }
      await fetchAttendee();
      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });
    } catch (error: any) {
      console.log(error.response);
      notificationRef.current?.show(
        error.response.data.message,
        notificationType.Error
      );
    }
  };

  let attendeeAvatar = (
    <FdAvatar sx={classes.attendeeAvatar} src={currentAttendee?.imageUrl} />
  );

  const customFields = getVisibleCustomFields();

  // const validate = {
  //   maxLength: (v: string | any[]) =>
  //     v.length <= 50 || "The email should have at most 50 characters",
  //   matchPattern: (v: string) =>
  //     /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
  //     "Email address must be a valid address",
  // };

  // const validate = {
  //   matchPattern: (v: string) =>
  //   /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(v) ||
  //     "Email address must be a valid address",
  // };



  const assignReservationDialog = () => {
    setConfirmationDialog({
      open: true,
      title: "Assign Reservations",
      fullWidth: true,
      content: (
        <AssignReservations
          id={currentAttendee?.id}
          currentReservations={currentAttendee?.reservations}
          setCurrentAttendee={setCurrentAttendee}
        />
      ),
      onClose: showConfirmationDialog
    });
  }

  const manageCategoryDialog = (prevId: number) => {
    if (prevId) selectedCategory.current = prevId;
    setConfirmationDialog({
      open: true,
      title: "Manage categories",
      fullWidth: true,
      isLoading: false,
      content: (
        <CategoryOverview />
      ),
    });
  }
  useEffect(() => {
    if (currentAttendee) {
      allowNavigationRef.current = false; // ✅ Reset after redirect
    }
  }, [currentAttendee]);

  return (
    <>
      {!loading && (
        <Box sx={classes.wrapper}>
          <Box sx={classes.contentWrapper}>
            <Box sx={classes.topActions} aria-label="topActions">
              <Box sx={classes.infoTitle}>
                <Box sx={classes.userImage}>{attendeeAvatar}</Box>

                {currentAttendee && (
                  <Box textAlign="left">
                    <FdTypography
                      label={`${currentAttendee?.fieldValues.fname} ${currentAttendee?.fieldValues.lname}`}
                      variant="h2"
                      component="h2"
                      sx={{ marginBottom: "10px" }}
                    />
                    <FdTypography label={currentAttendee?.fieldValues.title} />
                    <FdTypography
                      label={currentAttendee?.fieldValues.company}
                    />
                  </Box>
                )}
              </Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                {currentAttendee?.id && <FdButton
                  variant="text"
                  color="primary"
                  size="small"
                  sx={{ mr: 2 }}
                  onClick={assignReservationDialog}
                  startIcon={<RiAddCircleLine />}
                  style={{ color: "#7BB225" }}
                >
                  Manage reservations
                </FdButton>}

                {currentAttendee && canManageAttendee && (
                  <>
                    <FdButton
                      sx={{ mx: 2 }}
                      size="small"
                      startIcon={attendeeIsCheckedIn ? <FiLogOut /> : <FiLogIn />}
                      onClick={() => showCheckWarning(attendeeIsCheckedIn)}
                      disabled={disableCheckButton}
                      ButtonName={`Check ${attendeeIsCheckedIn ? "out" : "in"}`}
                      variant="text"
                      style={{ color: "#7BB225" }}
                    />
                    <FdButton
                      sx={{ mx: 2 }}
                      size="small"
                      startIcon={<BiTrash />}
                      onClick={showDeleteDialog}
                      variant="text"
                      ButtonName="Delete"
                      style={{ color: "#7BB225" }}
                    />
                  </>
                )}
                {canManageAttendee && (
                  <FdButton
                    variant="contained"
                    color="primary"
                    size="small"
                    type="submit"
                    sx={{ mr: 2 }}
                    form="eventForm"
                    disabled={!isDirty}
                  >
                    Save
                  </FdButton>
                )}

                <Tooltip title="Refresh">
                  <div>
                    <FdIconButton
                      onClick={() => {
                        try {
                          if (
                            state.selectedEvent?.singleAttendeeSyncUrl &&
                            currentAttendee?.thirdPartyId !== null
                          ) {
                            notificationRef.current?.show(
                              "Fetching Attendee...",
                              notificationType.Info
                            );
                            fetch(
                              state.selectedEvent?.singleAttendeeSyncUrl +
                              currentAttendee?.thirdPartyId
                            ).then((response) => {
                              if (response.status === 200) {
                                notificationRef.current?.show(
                                  "Attendee fetched successfully",
                                  notificationType.Success
                                );
                              } else {
                                notificationRef.current?.show(
                                  "No Attendee Found",
                                  notificationType.Error
                                );
                              }
                            });
                          }
                        } catch (error) {
                          console.log("error", error);
                        }

                        fetchAttendee();
                      }}
                      size="small"
                      Icon={<FiRefreshCw />}
                      style={{ color: "#7BB225" }}
                    />
                  </div>
                </Tooltip>

                <FdIconButton
                  aria-label="close"
                  sx={classes.closeButton}
                  onClick={() => redirect(
                    `/${routePaths.EVENTS}/${eventId}/${routePaths.ATTENDEES}`
                  )}
                  size="large"
                  Icon={<CloseIcon />}
                />
              </Box>
            </Box>

            <Box sx={classes.formContent} className="formContent">
              <form
                id="eventForm"
                onSubmit={handleSubmit(onSubmit)}
                noValidate
                style={{ width: "100%", textAlign: "left" }}
              >
                <Box sx={classes.genericFields} className="genericFields">
                  <Box sx={classes.formTitle}>
                    <FdTypography
                      label="Generic information"
                      variant="h2"
                      component="h2"
                    />
                  </Box>
                  <Box sx={classes.formFields}>
                    {/* attendee name */}
                    <Grid container spacing={2} marginBottom="15px">
                      <Grid item xs={12} md={6}>
                        <FdTextField
                          required
                          register={register}
                          name="fname"
                          id="fname"
                          label="First Name"
                          placeholder=""
                          error={errors.fname?.type === "required"}
                          errorMsg={errors.fname && "First name is required"}
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <FdTextField
                          required
                          register={register}
                          name={getCustomFieldName("lname")}
                          label="Last Name"
                          error={errors.lname?.type === "required"}
                          errorMsg={errors.lname && "Last name is required"}
                        />
                      </Grid>
                    </Grid>

                    {/* ids */}
                    <Grid container spacing={2} marginBottom="15px">
                      <Grid item xs={12} md={6}>
                        <FdTextField
                          register={register}
                          name="thirdPartyId"
                          label="Third Party ID"
                          InputLabelProps={{
                            shrink: true,
                            onDoubleClick: showQRHandlerFactory("thirdPartyId"),
                          }}
                          disabled={
                            currentAttendee?.thirdPartyId ? true : false
                          }
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <FdTextField
                          register={register}
                          name="id"
                          label="Fielddrive ID"
                          InputLabelProps={{
                            shrink: true,
                            onDoubleClick: showQRHandlerFactory("id"),
                          }}
                          disabled
                        />
                      </Grid>
                    </Grid>

                    {/* email */}
                    <Box marginBottom="15px">
                      <FdTextField
                        name="email"
                        register={register}
                        id="email"
                        label="Email"
                      // error={!!errors?.email}
                      // //@ts-ignore
                      // errorMsg={errors?.email?.message}
                      // validationObject={validate}
                      />
                    </Box>

                    {/* Attendee category */}
                    <Box marginBottom="15px">
                      <Controller
                        {...register("categoryId")}
                        control={control}
                        render={({ field: { onChange, value } }) => (
                          <FdSelect
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            defaultValue={initialValues.categoryId}
                            label="Attendee Category"
                            name="categoryId"
                            onChange={onChange}
                            value={value || selectedCategory.current}
                          >
                            {state?.attendeeCategoriesList?.list?.map(
                              (category: IAttendeeCategory) => (
                                <MenuItem key={category.id} value={category.id} onClick={() => {
                                  selectedCategory.current = category.id;
                                }}>
                                  {category.name}
                                </MenuItem>
                              )
                            )}
                            <FdButton
                              variant="text"
                              color="primary"
                              size="small"
                              startIcon={<RiAddCircleLine />}
                              ButtonName="Add new category"
                              sx={{ pl: 2, py: 1, width: "100%", justifyContent: "flex-start", "&:hover": { backgroundColor: "rgba(123, 178, 37, 0.08)" } }}
                              onClick={() => manageCategoryDialog(value)}
                            />
                          </FdSelect>
                        )}
                      />
                    </Box>

                    {/* Registration status */}
                    <Box marginBottom="15px">
                      <Controller
                        {...register("registrationStatus")}
                        control={control}
                        render={({ field: { onChange, value } }) => (
                          <FdSelect
                            labelId="registrationStatus-label"
                            id="registrationStatus"
                            defaultValue={initialValues.registrationStatus}
                            label="Registration status"
                            name="registrationStatus"
                            onChange={onChange}
                            value={value}
                            disabled={attendeeIsCheckedIn}
                          >
                            {Object.values(registrationStatus).map(
                              (status: string) => (
                                <MenuItem
                                  key={status}
                                  value={status}
                                  disabled={
                                    status === registrationStatus.ATTENDED ||
                                    status === registrationStatus.CHECKED_OUT
                                  }
                                >
                                  {status}
                                </MenuItem>
                              )
                            )}
                          </FdSelect>
                        )}
                      />
                    </Box>

                    {/* Last seen at */}
                    <Box
                      display="flex"
                      sx={{ alignItems: "flex-end" }}
                      flexWrap="wrap"
                      justifyContent="end"
                      marginBottom="15px"
                    >
                      <Box flexGrow={1}>
                        <FdTextField
                          register={register}
                          name="lastSeenAt"
                          label="Last seen time"
                          disabled
                        />
                      </Box>
                      <Box sx={{ ml: 2, position: "relative", top: "-5px" }}>
                        <FdButton
                          variant="outlined"
                          // color="primary"
                          size="medium"
                          onClick={() => setTimelineOpened(true)}
                          // className={classes.saveButton}
                          sx={{
                            textTransform: "uppercase",
                            color: theme.palette.text.primary,
                            borderColor: "rgba(0, 0, 0, 0.23)",
                            padding: "5px 15px",
                            mt: 2,
                            "&:hover": {
                              borderColor: theme.palette.text.primary,
                            },
                          }}
                          ButtonName=" Show full timeline"
                        />
                      </Box>
                    </Box>
                    {/* barcode */}
                    <Box
                      display="flex"
                      sx={{ alignItems: "flex-end" }}
                      flexWrap="wrap"
                      justifyContent="end"
                    >
                      <Box flexGrow={1}>
                        <TextField
                          {...register("barcode")}
                          id="barcode"
                          label="Barcode"
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                            onDoubleClick: showQRHandlerFactory("barcode"),
                          }}
                          disabled={currentAttendee?.barcodeBlocked}
                        />
                      </Box>
                      {canManageAttendee && (
                        <Box sx={{ ml: 2, position: "relative", top: "-5px" }}>
                          <FdButton
                            variant="outlined"
                            // color="primary"
                            size="medium"
                            onClick={showInvalidateBarcodeDialog}
                            // className={classes.saveButton}
                            sx={{
                              textTransform: "uppercase",
                              color: theme.palette.text.primary,
                              borderColor: "rgba(0, 0, 0, 0.23)",
                              padding: "5px 15px",
                              "&:hover": {
                                borderColor: theme.palette.text.primary,
                              },
                            }}
                            disabled={!currentAttendee}
                          >
                            Invalidate
                          </FdButton>
                        </Box>
                      )}
                    </Box>

                    {/* balance due */}
                    {/* <TextField
                          name="balanceDue"
                          label="Balance Due"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          InputProps={{
                            disableUnderline: true,
                            className: classes.textField,
                          }}
                        /> */}

                    {values && (
                      <Grid container justifyContent="center">
                        <Grid item>
                          {/* <Box
                          className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink Mui-disabled Mui-disabled MuiFormLabel-filled"
                          onDoubleClick={showQRHandlerFactory("barcode")}
                        >
                          QR code:
                        </Box> */}
                          <Box
                            sx={{
                              p: 1,
                              bgcolor: "white",
                              display: "inline-flex",
                              borderRadius: 1,
                              mt: 2,
                            }}
                            onDoubleClick={showQRHandlerFactory("barcode")}
                          >
                            <QRCode value={values} level="M" renderAs="svg" />
                          </Box>
                        </Grid>
                      </Grid>
                    )}
                  </Box>
                </Box>
                <Box sx={classes.customFields} className="customFields">
                  <Box sx={classes.formTitle}>
                    <FdTypography
                      label="Custom attributes"
                      variant="h2"
                      component="h2"
                    />
                  </Box>
                  <Box>
                    <Box padding="10px 20px">{customFields}</Box>
                  </Box>
                  {canManageAttendee && (
                    <Box
                      sx={classes.addInfoFieldButton}
                      onClick={() => showInfoFieldDialog()}
                    >
                      <BiPlusCircle
                        style={{
                          color: "#fff",
                          marginRight: "5px",
                          fontSize: "18px",
                        }}
                      />{" "}
                      <FdTypography
                        label="Add new infofield"
                        component="span"
                        sx={{
                          color: "#fff",
                          fontSize: "18px",
                        }}
                      />
                    </Box>
                  )}
                </Box>
                <RouteLeavingGuard
                  when={isDirty && !allowNavigationRef.current}
                  navigate={(path) => navigate(path)}
                  shouldBlockNavigation={(location) => isDirty && !allowNavigationRef.current}
                />
                <Dialog
                  open={popoutQR}
                  onClose={() => setPopoutQR(false)}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box
                    sx={{
                      p: 1,
                      bgcolor: "white",
                      display: "inline-flex",
                      borderRadius: 6,
                    }}
                  >
                    {values ? (
                      <QRCode
                        value={values}
                        level="M"
                        renderAs="svg"
                        size={256}
                        onClick={() => setPopoutQR(false)}
                      />
                    ) : (
                      "No data in this field. Double click another field to generate a QR code."
                    )}
                  </Box>
                </Dialog>
              </form>
            </Box>
          </Box>
        </Box>
      )}

      {loading && <Loading />}

      <NotificationMessage ref={notificationRef} />

      {confirmationDialog.open && (
        <SimpleActionDialog
          type={confirmationDialog.type}
          icon={confirmationDialog.icon}
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          isLoading={confirmationDialog.isLoading}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
          onClose={handleDialogClose}
          content={confirmationDialog.content}
          confirmLabel={confirmationDialog.confirmLabel}
          fullWidth={confirmationDialog.fullWidth}
        />
      )}
      {currentAttendee && state?.selectedEvent && (
        <AttendeeTimelinePopup
          attendee={currentAttendee}
          timezone={state?.selectedEvent?.timeZone}
          open={timelineOpened}
          handleClose={() => {
            setTimelineOpened(false);
          }}
        />
      )}
    </>
  );
};

export default AttendeeEdit;
